// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/profile_cover_type.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file accounts/profile_cover_type.proto.
 */
export const file_accounts_profile_cover_type: GenFile = /*@__PURE__*/
  fileDesc("CiFhY2NvdW50cy9wcm9maWxlX2NvdmVyX3R5cGUucHJvdG8SD3Byb3Rvcy5hY2NvdW50cypQChBQcm9maWxlQ292ZXJUeXBlEh4KGlBST0ZJTEVfQ09WRVJfVFlQRV9VTktOT1dOEAASHAoYUFJPRklMRV9DT1ZFUl9UWVBFX0lNQUdFEAFiBnByb3RvMw");

/**
 * @generated from enum protos.accounts.ProfileCoverType
 */
export enum ProfileCoverType {
  /**
   * @generated from enum value: PROFILE_COVER_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PROFILE_COVER_TYPE_IMAGE = 1;
   */
  IMAGE = 1,
}

/**
 * Describes the enum protos.accounts.ProfileCoverType.
 */
export const ProfileCoverTypeSchema: GenEnum<ProfileCoverType> = /*@__PURE__*/
  enumDesc(file_accounts_profile_cover_type, 0);

